import { store } from "../store";
import { arr } from "../data/LanguageTranslate";

export const getTranslation = (key) => {
  const language = store.getState().language.language;

  if (language == "en") {
    return key;
  }

  return arr[key] || key;
};